import { toUKTime } from "@/lib/dateHelper"

type DrawNameSource = {
  entryDeadlineDateTime: string
  // Optional here (required in the API type) so pre-SO-33724 draws without a name still render.
  displayName?: string | null
}

function getDisplayName(draw: DrawNameSource): string | null {
  return draw.displayName?.trim() || null
}

export function getDrawMonth(draw: DrawNameSource): string {
  return toUKTime(draw.entryDeadlineDateTime).format("MMMM")
}

/**
 * Single source of truth for draw naming. The BE displayName has no short
 * form, so it is returned for both forms; the month-based name is the fallback.
 */
export function getDrawName(draw: DrawNameSource, shortName = false): string {
  const displayName = getDisplayName(draw)
  if (displayName) return displayName

  const month = getDrawMonth(draw)
  return shortName ? `${month} draw` : `${month} prize draw`
}

/** For headings that add their own noun ("… results are on the way"): bare month, not "July draw". */
export function getDrawHeadingName(draw: DrawNameSource): string {
  return getDisplayName(draw) ?? getDrawMonth(draw)
}
